import {
  AppCode,
  AppCodeUse,
  Collection,
  Experience,
  ExperienceGuidePage,
  ExperienceMessage,
  Goal,
  GoalParticipant,
  TmsJob,
  User
} from 'data/records'
import { appCodeInitialState, appCodeReducers } from 'data/resources/appCodes'
import { appCodeUseInitialState, appCodeUseReducers } from 'data/resources/appCodeUses'
import { collectionReducers, collectionInitialState } from 'data/resources/collections'
import { experienceInitialState, experienceReducers } from 'data/resources/experiences'
import { experienceGuidePageInitialState, experienceGuidePageReducers } from 'data/resources/experienceGuidePages'
import { experienceMessageInitialState, experienceMessageReducers } from 'data/resources/experienceMessages'
import { favoriteReducers } from 'data/resources/favorites'
import { followReducers } from 'data/resources/follows'
import { goalReducers, goalFreeReducers, goalInitialState } from 'data/resources/goals'
import { goalParticipantReducers, goalParticipantInitialState } from 'data/resources/goalParticipants'
import { liveLogReducers } from 'data/resources/liveLogs'
import { routeReducers } from 'data/resources/routes'
import { routeSetOverviewReducers } from 'data/resources/routeSetOverviews'
import { segmentMatchReducers } from 'data/resources/segmentMatches'
import { tmsJobInitialState, tmsJobReducers } from 'data/resources/tmsJobs'
import { tripReducers } from 'data/resources/trips'
import { userInitialState, userReducers } from 'data/resources/users'

// All apiv3 resource reducers to be run after the default record/collection/extras reducers
export const resourceReducers = {
  ...appCodeReducers,
  ...appCodeUseReducers,
  ...collectionReducers,
  ...experienceReducers,
  ...experienceGuidePageReducers,
  ...experienceMessageReducers,
  ...favoriteReducers,
  ...followReducers,
  ...goalReducers,
  ...goalParticipantReducers,
  ...liveLogReducers,
  ...routeReducers,
  ...routeSetOverviewReducers,
  ...segmentMatchReducers,
  ...tmsJobReducers,
  ...tripReducers,
  ...userReducers
}

// these resource reducers are handed the entire apiv3 state record, and can thus update
// apiv3 state on other resources
export const freeReducers = {
  ...goalFreeReducers
}

// All apiv3 resource state to be included in addition to standard record-by-id mapping
export const resourceState = [
  [AppCode, appCodeInitialState],
  [AppCodeUse, appCodeUseInitialState],
  [Collection, collectionInitialState],
  [Experience, experienceInitialState],
  [ExperienceGuidePage, experienceGuidePageInitialState],
  [ExperienceMessage, experienceMessageInitialState],
  [Goal, goalInitialState],
  [GoalParticipant, goalParticipantInitialState],
  [TmsJob, tmsJobInitialState],
  [User, userInitialState]
]
